export const fonts = {
  heading:
    "'Geist Variable', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Droid Sans', 'Helvetica Neue', sans-serif",
  body: "'Geist Variable', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Droid Sans', 'Helvetica Neue', sans-serif",
  mono: "'Geist Mono Variable', source-code-pro, 'Menlo', 'Monaco', 'Consolas', 'Courier New', monospace",
};

export const fontSizes = {
  xs: "10px",
  sm: "12px",
  md: "14px",
  lg: "16px",
  xl: "18px",
  "2xl": "20px",
  "3xl": "24px",
  "4xl": "28px",
  "5xl": "32px",
  "6xl": "40px",

  future: {
    "2xs": "10px",
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "24px",
    "2xl": "32px",
  },
};

export const fontWeights = {
  thin: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const letterSpacings = {
  tighter: "-0.1em",
  tight: "-0.05em",
  normal: "0em",
  wide: "0.1em",
  wider: "0.3em",
  widest: "0.9em",
};

export const lineHeights = {
  singleLine: 1,
  multiLine: 1.5,
  tabs: "1.25rem",
};
